import React, { useContext, useEffect, useState } from 'react';
import Sider from '../Sider/Sider';
import Header from '../Header/Header';
import AppContext from '../../../context/AppContext';

// import { Container } from './styles';

function Layout({ children, name }) {
  const {isExpanded, setIsExpanded, setIsDropdownOpen, setWhichDropdownOpen} = useContext(AppContext)

  useEffect(() => {
    setIsExpanded(false);
    setIsDropdownOpen(false);
    if (name) {
      setWhichDropdownOpen([name]);
    }
  }, []);

  return (
    <div className="pageContainer">
      <Header isExpanded={isExpanded} setIsExpanded={setIsExpanded}/>
      <div style={{display: 'flex'}}>
        <Sider isExpanded={isExpanded} />
        <div className={`contentContainer ${isExpanded ? 'expanded' : 'collapsed'}`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;